import { orReducer } from './orReducer';
import type { AppPaneUnderlayViewState } from '../store/schema/AppPaneUnderlayViewState';
import getStore from '../store/store';

export default function isAppPaneUnderlayExpanded(
    underlay?: AppPaneUnderlayViewState
): boolean | undefined {
    const store = underlay || getStore();
    return [...store.isShown.values()].reduce(orReducer, false);
}
